<template>
<div>
    <template v-if="isLoading">
      <template v-if="!isInit || !isError">
        <loading :message="'データ読み込み中...'"></loading>
      </template>
    </template>
    <template v-else>

      <template v-for="item in dataList">

        <template v-if="dataList.length > 0">

          <div id="comment-list" v-bind:key="item.shinsei_id">

          <!-- コメント内容 -->
          <article class="post-type-comment me">
            <!-- icon -->
            <div class="icon-container">
              <div class=" icon">
                <img :src="Const.PEOPLE_ICON_PATH">
              </div>

              <template v-if="item.syounin_status_type === OptionConst.SYOUNIN_STATUS.WAIT">
                <div class=" icon">
                  <img :src="Const.SYOUNIN_STATUS_WAIT_ICON_PATH">
                </div>
              </template>

              <template v-if="item.syounin_status_type === OptionConst.SYOUNIN_STATUS.APPROVED">
                <div class=" icon">
                  <img :src="Const.SYOUNIN_STATUS_APPROVED_ICON_PATH">
                </div>
              </template>

              <template v-if="item.syounin_status_type === OptionConst.SYOUNIN_STATUS.DENIED">
                <div class=" icon">
                  <img :src="Const.SYOUNIN_STATUS_DENIED_ICON_PATH">
                </div>
              </template>
            </div>

            <div class="post-body">
              <div class="post-info">
                <p class="name">{{ item.staff_name }}</p>
                <p class="date">{{dateFormat(item.updated_at)}}　{{ timeFormat(item.updated_at)}}</p>
              </div>
              <div class="post-content">

                <div class="zangyou-jikan">
                  <template v-if="item.jikangai">
                    <p class="date">{{ dateFormat(item.jikangai.jikangai_date)}}</p>
                    <p>{{ item.jikangai.start_time }}
                        ～
                        {{ item.jikangai.end_time }}</p>
                  </template>
                  <template v-if="item.kyuukei_jikangai">
                    <p class="date">{{ dateFormat(item.kyuukei_jikangai.kyuukei_jikangai_date)}}</p>
                    <p>{{ item.kyuukei_jikangai.kyuukei_jikangai_times }}</p>
                  </template>
                </div>

                <!-- 業務内容 -->
                <p class="pre-wrap transform-italic">
                  <template v-if="item.jikangai">
                    {{ item.jikangai.gyoumu_notes }}
                  </template>
                  <template v-if="item.kyuukei_jikangai">
                    {{ item.kyuukei_jikangai.gyoumu_notes }}
                  </template>
                </p>

                <!-- 備考欄 -->
                <template v-if="item.notes">
                  <p class="pre-wrap transform-italic">{{ item.notes}}</p>
                </template>

              </div>
            </div>
          </article>

          <!-- 承認・否認コメント -->
          <template v-for="comment in item.zangyou_comment">
            <template v-if="comment.user_id">
              <article class="post-type-comment other"  v-bind:key="comment.syounin_group_flow_id">
                <div class=" icon">
                  <img :src="Const.PEOPLE_ICON_PATH">
                </div>
                <div class="post-body">
                  <div class="post-info">
                    <p class="name">{{ comment.staff_name }}</p>
                    <p class="date">{{ dateFormat(comment.updated_at) }}　{{ timeFormat(comment.updated_at)}}</p>
                  </div>
                  <div class="post-content">
                    <p class="pre-wrap transform-italic">{{ comment.status_notes ? comment.status_notes : '(コメントなし)' }}</p>
                  </div>
                </div>
              </article>
            </template>
          </template>

          <!-- 再申請コメント -->
          <template v-for="saishinsei in item.zangyou_saishinsei">
            <template v-if="saishinsei.jikangai">

              <!-- コメント内容 -->
              <article class="post-type-comment me">

                <!-- icon -->
              <div class="icon-container">
                <div class=" icon">
                  <img :src="Const.PEOPLE_ICON_PATH">
                </div>

                <template v-if="saishinsei.syounin_status_type === OptionConst.SYOUNIN_STATUS.WAIT">
                  <div class=" icon">
                    <img :src="Const.SYOUNIN_STATUS_WAIT_ICON_PATH">
                  </div>
                </template>

                <template v-if="saishinsei.syounin_status_type === OptionConst.SYOUNIN_STATUS.APPROVED">
                  <div class=" icon">
                    <img :src="Const.SYOUNIN_STATUS_APPROVED_ICON_PATH">
                  </div>
                </template>

                <template v-if="saishinsei.syounin_status_type === OptionConst.SYOUNIN_STATUS.DENIED">
                  <div class=" icon">
                    <img :src="Const.SYOUNIN_STATUS_DENIED_ICON_PATH">
                  </div>
                </template>
              </div>

              <div class="post-body">
                <div class="post-info">
                  <p class="name">{{ item.staff_name }}</p>
                  <p class="date">{{ dateFormat(saishinsei.jikangai.updated_at) }}　{{ timeFormat(saishinsei.jikangai.updated_at) }}</p>
                </div>
                <div class="post-content">

                  <div class="zangyou-jikan">
                    <p class="date">{{ dateFormat(saishinsei.jikangai.jikangai_date) }}</p>
                    <p>{{ saishinsei.jikangai.start_time }}
                      ～
                      {{ saishinsei.jikangai.end_time }}</p>
                  </div>

                  <!-- 業務内容 -->
                  <p class="pre-wrap transform-italic">{{ saishinsei.jikangai.gyoumu_notes }}</p>
                  <!-- 備考欄 -->
                  <template v-if="saishinsei.notes">
                    <p class="pre-wrap transform-italic">{{ saishinsei.notes }}</p>
                  </template>

                </div>
              </div>

              </article>

              <!-- 承認・否認コメント -->
              <template v-for="saishinseicomment in saishinsei.zangyou_comment">
                <template v-if="saishinseicomment.user_id">
                  <article class="post-type-comment other"  v-bind:key="saishinseicomment.syounin_group_flow_id">
                    <div class=" icon">
                      <img :src="Const.PEOPLE_ICON_PATH">
                    </div>
                    <div class="post-body">
                      <div class="post-info">
                        <p class="name">{{ saishinseicomment.staff_name }}</p>
                        <p class="date">{{ dateFormat(saishinseicomment.updated_at) }}　{{ timeFormat(saishinseicomment.updated_at) }}</p>
                      </div>
                      <div class="post-content">
                        <p class="pre-wrap transform-italic">{{ saishinseicomment.status_notes ? saishinseicomment.status_notes : '(コメントなし)' }}</p>
                      </div>
                    </div>
                  </article>
                </template>
              </template>

            </template>

          </template>

          </div>

        </template>

      </template>

  </template>
</div>
</template>

<script lang="ts">
import { defineComponent} from "vue";
import { dateFormat, timeFormat } from "@/filters/common";
import Const from '@/const/Shinsei/Option';
import OptionConst from "@/const/Option";

export default defineComponent({
  props: ["dataList", "isLoading", "isError", "isInit"],
  setup() {
    return {
      dateFormat,
      timeFormat,
      Const,
      OptionConst,
    };
  },
  components: {},
});
</script>

<style lang="scss" scoped>
@import '@scss/components/shinsei-zangyou-list.scss';
</style>
